import { render } from "./TablesFloor.vue?vue&type=template&id=506d8d6b&scoped=true"
import script from "./TablesFloor.vue?vue&type=script&lang=js"
export * from "./TablesFloor.vue?vue&type=script&lang=js"

import "./TablesFloor.vue?vue&type=style&index=0&id=506d8d6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506d8d6b"]])

export default __exports__